import { render, staticRenderFns } from "./TheMain.vue?vue&type=template&id=1c7e529f&"
import script from "./TheMain.vue?vue&type=script&lang=js&"
export * from "./TheMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports